module.exports = __webpack_public_path__ + "static/media/new_CISOSCOPE_logo_complete_blue.64ec2b5d.svg";